module.exports = __webpack_public_path__ + "static/media/kchess_tc_og_image.f5e626d1.png";